import { type LoaderFunction } from 'react-router';
import { updatePage } from '../../reducers/app/appReducer';
import store from '../../store';
import { loadDataForSelectedService } from './loaderHelper';
import services from '../../services';
import type { Question } from '../../services/additionalInfo/model';
import { viewContext } from '../middleware/context';

export interface ContactPageLoaderData {
  mandatoryQuestions: Question[];
}

const DEMarketTempQuestionsFilter = (
  storeId: string,
  questions: Question[],
): Question[] => {
  return questions.filter((question) => {
    if (question.id === 1161) {
      return storeId === 'plan69';
    }
    return true;
  });
};

const loader: LoaderFunction = async ({
  context,
}): Promise<ContactPageLoaderData> => {
  const view = context.get(viewContext);
  store.dispatch(updatePage('contact'));
  const { service, storeId } = await loadDataForSelectedService(view);

  const { result } = await services.additionalInfo.getMandatoryQuestions(
    service.serviceId,
  );

  let mandatoryQuestions = result;
  if (Array.isArray(mandatoryQuestions)) {
    if (view === 'app') {
      mandatoryQuestions = mandatoryQuestions.filter(
        (question) => question.type !== 'FILE',
      );
    } else if (
      CSS_CONFIG.country === 'de' &&
      service.serviceId === 'BUSINESS_PLANNING'
    ) {
      mandatoryQuestions = DEMarketTempQuestionsFilter(
        storeId,
        mandatoryQuestions,
      );
    }
    return { mandatoryQuestions };
  }
  return { mandatoryQuestions: [] };
};

export default loader;
